export class AppRoutes {
  public static readonly routeHome = '/';
  public static readonly routeDsnList = '/dsn-list';
  public static readonly routeDsnDetail = '/dsn-list/:instanceId';
  public static readonly routeBilanDetail = '/dsn-list/:instanceId/bilans/:bilanId';
  public static readonly routeUserAccount = '/register';
  public static readonly routeErrorPage = '/error-page';
  public static readonly routeUnauthorized = '/unauthorized';
  public static readonly routeCallback = '/callback';
  public static readonly routeLogin = '/login';
  public static readonly routeLogout = '/logout';
  public static readonly routeAdmin = '/admin';
  public static readonly routeKeyAuth = '/key-auth';
  public static readonly routeDebugInfos = '/debug-infos';
  public static readonly routeDebugErrorTest = '/debug-error-test';
  public static readonly routeDebugErrorTestPublic = '/debug-error-test-public';
}
